import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  setStepAddOrderFormValues,
  setStepOrderTableFetchDataFlag,
} from "../../../Features/Step/stepSlice";
import { toast } from "react-toastify";
import TabBox from "../../../Components/Tabbox/TabBox";
import {
  addStepShekarOrder,
  getStepInstruments,
} from "../../../Requests/stepRequests";
import TextInput from "../../../Components/TextInput";
import Button from "../../../Components/Button";
import {
  IStepAddOrderFormValues,
  IStepOptionDropdownItem,
  StepInstrumentType,
  StepOptionOrderType,
  StepOrderSide,
  StepOrderTypes,
} from "../../../Interfaces/stepInterfaces";
import SahraConnections from "../../Sahra/SahraConnections";
import StaticDropdown from "../../../Components/Dropdown/StaticDropdown";
import Modal from "../../../Components/Modal/Modal";
import Form from "../../../Components/Form";
import UsersMultiSelectDropdown from "../../../Components/Dropdown/Users/UsersMultiSelectDropdown";
import CustomDynamicDropdown from "../../../Components/Dropdown/CustomDropdown/CustomDynamicDropdown";
import BulkOrder from "./BulkOrder";
import SingleOrder from "./SingleOrder";

enum ModalMode {
  SahraUsers,
}

const AddOrderBox = () => {
  const formValues = useAppSelector((store) => store.manual.addOrderFormValues);

  return (
    <div className="flex flex-col justify-start items-center gap-5">
      <SingleOrder formValues={formValues} />
      <BulkOrder />
    </div>
  );
};

export default AddOrderBox;
